import React, { Component } from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {Tooltip} from 'antd';
import ProgressForTable from './ProgressForTable.js';
import Loading from '../../commons/Loading.js';
import ToolBar from '../../commons/ToolBar.js';
import SvgIcon from '../../commons/SvgIcon';

class SystemUsageVMList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            vmData: this.props.vmData,
            loading: this.props.loading,
            showHostName: this.props.showHostName
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            vmData: nextProps.vmData,
            loading: nextProps.loading,
            showHostName: nextProps.showHostName
        });
    }

    hostNameFormat = (cell, row) => {
        return (
            <div style={{display: 'flex'}}>
                <a href="#" onClick={() => this.setHostName(row.hostName)}>{cell}</a>
                <div style={{display: row.pinned ? 'block' : 'none'}}>
                    <SvgIcon name="pin_on" style={{fontSize: 12, height: 'inherit'}}/>
                </div>
            </div>
        )
    }

    appNameFormat = (cell, row, enumObject, rowIndex) => {
        let cellShow = '';
        if (cell === 'ORION') {
            cellShow = 'Orion';
        } else if (cell === 'PDMS') {
            cellShow = 'PDMS';
        }

        return (
            <div style={{textAlign: 'center'}}>
                { cellShow }
            </div>
        );
    }

    progressCPUFormat = (cell, row) => {
        return <ProgressForTable percent={cell} level={row.cpuLevel}/>;
    }
    progressDiskFormat = (cell, row) => {
        return <ProgressForTable percent={cell} level={row.diskLevel}/>;
    }
    progressMemoryFormat = (cell, row) => {
        return <ProgressForTable percent={cell} level={row.memoryLevel}/>;
    }

    alertCountFormatter = (cell, row) => {
        const listItems = row.alert.map((item) =>
            <small key={item}>{item}</small>
        );
        const tips = (
            <div style={{display: 'grid'}}>
                {listItems}
                <small style={{display: row.containerAlert.length > 0 ? 'block' : 'none'}}>Container Alert
                    : {row.containerAlert.length}</small>
            </div>);
        return (
            <div>
                <div style={{textAlign: 'center', color: '#D11C23', display: cell > 0 ? 'block' : 'none'}}>
                    <Tooltip title={tips}>
                        {cell}
                    </Tooltip>
                </div>
                <div style={{textAlign: 'center', display: cell > 0 ? 'none' : 'block'}}>
                    {cell}
                </div>
            </div>
        )
    }

    setHostName = (hostname) => {
        this.setState({showHostName: hostname});
        this.props.updateShowHostName(hostname);
    }

    createCustomToolBar = props => {
        const showHostName = this.state.showHostName;
        return (
            <div>
                <div className='buttonFiled' style={{ display: showHostName === '' ? 'block' : 'none' }}>
                    <ToolBar onFresh={this.props.onFresh}/>
                </div>
                <div className='searchFiled' style={{width: showHostName === '' ? '': '100%'}}>
                    { props.components.searchPanel }
                </div>
            </div>
        );
    }

    trClassFormat = (row, rowIndex) => {
        if (row.hostName === this.state.showHostName) {
            return "table_selected_row";
        }
    };

    render() {
        const { vmData, showHostName } = this.state;
        const showSlide = showHostName !== "";
        const options = {
            defaultSortName: 'hostName',
            defaultSortOrder: 'asc',
            toolBar: this.createCustomToolBar,
            noDataText: this.state.loading ? <Loading /> : 'No virtual machine found.',
            searchDelayTime: 500
        };
        return (
            <BootstrapTable data={ vmData } search={ true } options={ options }
                            trClassName={this.trClassFormat} striped hover condensed>
                <TableHeaderColumn dataField='hostName' isKey dataSort={ true }
                                   dataFormat={this.hostNameFormat} width="30%">Host Name</TableHeaderColumn>
                <TableHeaderColumn dataField='appName' dataSort={ true }
                                   dataFormat={this.appNameFormat} width="9%">App Name</TableHeaderColumn>
                <TableHeaderColumn dataField='alertCount' dataSort={ true } dataFormat={this.alertCountFormatter}
                                   width="7%" hidden={showSlide}>Alerts</TableHeaderColumn>
                <TableHeaderColumn dataField='cpu' dataSort={ true } dataFormat={ this.progressCPUFormat } width="15%"
                                   hidden={showSlide}>CPU</TableHeaderColumn>
                <TableHeaderColumn dataField='memory' dataSort={ true } dataFormat={ this.progressMemoryFormat }
                                   width="15%" hidden={showSlide}>Memory</TableHeaderColumn>
                <TableHeaderColumn dataField='disk' dataSort={ true } dataFormat={ this.progressDiskFormat } width="15%"
                                   hidden={showSlide}>Disk</TableHeaderColumn>
                <TableHeaderColumn dataField='containerCount' dataSort={ true } width="9%"
                                   hidden={showSlide}>Containers</TableHeaderColumn>
            </BootstrapTable>
        );
    }
}

export default SystemUsageVMList;


// WEBPACK FOOTER //
// ./src/modules/system-usage/SystemUsageVMList.js